module.exports = __webpack_public_path__ + "static/media/guide-rings.e086615b.svg";